module.exports = __webpack_public_path__ + "media/images/popover/illustration-4-cropped-5be27347ae72e7df4cc72686040e2c40.png";